import {
	Box,
	Checkbox,
	FormControlLabel,
	FormHelperText,
	TextField,
	Typography,
} from "@mui/material";

import { Fragment, useEffect, useState } from "react";
import { Controller } from "react-hook-form";

export const CancelForm = ({ form, order }) => {
	const [products, setProducts] = useState([]);
	const {
		control,
		register,
		formState: { errors },
	} = form;
	useEffect(() => {
		setProducts(order?.lines);
	}, [order]);

	return (
		<Fragment>
			<Box my={1}>
				<Typography>Products</Typography>
				<Box
					my={2}
					sx={{ display: "flex", flexDirection: "column", gap: 2 }}
				>
					{products.map((product, index) => (
						<Box
							key={product.id}
							sx={{
								p: 2,
								mx: 1,
								// mb: 2,
								border: "1px solid",
								borderColor: "grey.400",
								borderRadius: 1,
							}}
						>
							<Typography variant="body1" gutterBottom>
								{product.title}
							</Typography>
							<Controller
								name={`products.${index}.id`}
								control={control}
								defaultValue={product.id}
								render={({ field }) => (
									<input type="hidden" {...field} />
								)}
							/>
							<Box sx={{ display: "flex", gap: 2 }}>
								<Controller
									name={`products.${index}.undeliverable`}
									control={control}
									defaultValue={false}
									render={({ field }) => (
										<FormControlLabel
											control={
												<Checkbox
													{...field}
													checked={field.value}
												/>
											}
											label="Undeliverable"
										/>
									)}
								/>
								<Controller
									name={`products.${index}.out_of_stock`}
									control={control}
									defaultValue={false}
									render={({ field }) => (
										<FormControlLabel
											control={
												<Checkbox
													{...field}
													checked={field.value}
												/>
											}
											label="Unavailable"
										/>
									)}
								/>
							</Box>
							{errors.products?.[index] && (
								<FormHelperText error>
									{errors.products[index].undeliverable
										?.message ||
										errors.products[index].unavailable
											?.message}
								</FormHelperText>
							)}
						</Box>
					))}
				</Box>
			</Box>

			<Box my={3}>
				<TextField
					// InputLabelProps={{ shrink: true }}
					{...register("reason", {})}
					fullWidth
					label="Reason (Optional)"
					variant="outlined"
					multiline
					minRows={3}
					// value={brand.name}
					error={Boolean(errors.reason)}
					helperText={errors.reason?.message}
				/>
			</Box>
		</Fragment>
	);
};
